import Vue from 'vue';
import Router, { RouterOptions, Route, RouteRecord } from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
  ],
} as RouterOptions);

export default router;
